import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { store } from "@/store";
import { delay } from "lodash";
import MiniBasketB2b from "@/ui/shared/MiniBasketB2B.vue";
import MiniBasketB2c from "@/ui/shared/MiniBasketB2C.vue";
import OffcanvasNavigation from "@/ui/chrome/OffCanvasNavigation.vue";
import viewportEventsService from "@/core/responsive/viewport/viewport-events.service";
import PortalTopBar from "./PortalTopBar.vue";
import NavigationSearch from "@/ui/shared/NavigationSearch.vue";
import UspItem from "./UspItem.vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBarNavigation',
  setup(__props) {

const isCheckoutView = computed<boolean>(() => store.getters["app/isCheckoutView"]);
const isBasketVisible = computed<boolean>(() => store.getters["app/isBasketVisible"]);
const isOnSearchPage = computed<StringFunction>(() => store.getters["app/isOnSearchPage"]);
const showAuthTopBar = computed<boolean>(() => store.getters["app/showAuthTopBar"]);
const isCheckoutViewWithTopBar = computed<boolean>(() => store.getters["app/isCheckoutViewWithTopBar"]);
const menuTheme = computed<MenuThemeSettings>(() => store.getters["app/menuTheme"]);
const usp = computed<IUsp>(() => store.getters["app/usp"]);
const isB2BAuthenticated = computed<boolean>(() => store.getters["app/isB2BAuthenticated"]);

const lineItemsCount = computed<number>(() => store.getters["basket/lineItemsCount"]);

const isSearchOpen = computed<boolean>(() => store.getters["navigation/isSearchOpen"]);
const isMiniBasketOpen = computed<boolean>(() => store.getters["navigation/isMiniBasketOpen"]);

function toggleSearch(canOpenSearch?: boolean) : void {
    store.dispatch("navigation/toggleSearch", canOpenSearch);
}
function toggleBasket() : void {
    store.dispatch("navigation/toggleBasket");
}
function toggleNavigation() : void {
    store.dispatch("navigation/toggleNavigation");
}
function closeNavigationOverlays() : void {
    store.dispatch("navigation/closeNavigationOverlays");
}

const addToBasketSuccess = ref<boolean>(false);
const basketSuccessTimer = ref<any>();
const popoutOpen = ref<boolean>(false);

const scrollCallbackIndex = ref<number | undefined>();
const lastAnchor = ref<number>(0);
const lastScrollTop = ref<number>(0);
const scrollSign = ref<number>(0);

const showNavigation = computed<boolean>(() => !isCheckoutView.value || isCheckoutViewWithTopBar.value);

const topBarNavigationWrapper = ref(null);

onMounted(() => {
    scrollCallbackIndex.value = viewportEventsService.setCallback(onScroll);
});

function searchIconClicked() {
    if (canOpenSearch.value) {
        const currentScrollTop = viewportEventsService.viewport.scrollY;
        lastAnchor.value = currentScrollTop;
        lastScrollTop.value = currentScrollTop;
        resetWrapperTransform();
    }
    toggleSearch(canOpenSearch.value);
}

function navigationIconClicked() {
    const currentScrollTop = viewportEventsService.viewport.scrollY;
    lastAnchor.value = currentScrollTop;
    lastScrollTop.value = currentScrollTop;
    resetWrapperTransform();
    toggleNavigation();
}

function onScroll() {
    if (!showNavigation.value) {
        return;
    }
    const currentScrollTop = viewportEventsService.viewport.scrollY;
    if (currentScrollTop > 0 && lastScrollTop.value < currentScrollTop) {
        // Scrolling down
        const mainNavigationHeight = topBarNavigationWrapper.value.getBoundingClientRect().height;
        const topPosition = Math.min(mainNavigationHeight, currentScrollTop - lastAnchor.value);
        topBarNavigationWrapper.value.style.transform = "translateY(" + (-topPosition) + "px)";
        scrollSign.value = 1;
    } else if (lastScrollTop.value > currentScrollTop) {
        lastAnchor.value = currentScrollTop;
        resetWrapperTransform();
        scrollSign.value = -1;
    }
    lastScrollTop.value = currentScrollTop;
}

const whiteText = computed<boolean>(() => {
    return menuTheme.value.whiteMenuText && !menuIsWhite.value;
});

const menuIsWhite = computed<boolean>(() => {
    return popoutOpen.value || isSearchOpen.value || lastAnchor.value > 0;
});

const splashColors = computed<any>(() => {
    return [
        whiteText.value ? "u-bg-white u-text-black" : "u-bg-black u-text-white"
    ];
});

function resetWrapperTransform() {
    topBarNavigationWrapper.value.style.transform = "";
}

onBeforeUnmount(() => {
    viewportEventsService.removeCallback(scrollCallbackIndex.value);
});

const route = useRoute();
const canOpenSearch = computed<boolean>(() => {
    return !isOnSearchPage.value(route.path);
});

const routeValues = computed<RouteValues>(() => ({ path: route.path, query: route.query, fullPath: route.fullPath }));
watch(routeValues, onUrlChange, { deep: true });

function onUrlChange(): void {
    closeNavigationOverlays();
    togglePopout(false);
}

watch(lineItemsCount, onLineItemCountChange);
function onLineItemCountChange() {
    showAddToBasketSuccessAnimation();
}

function showAddToBasketSuccessAnimation(): void {
    addToBasketSuccess.value = true;
    tryClearBasketSuccessTimer();
    basketSuccessTimer.value = delay(() => (addToBasketSuccess.value = false), 650);
}

function tryClearBasketSuccessTimer() {
    if (basketSuccessTimer.value) {
        clearTimeout(basketSuccessTimer.value);
    }
}

function togglePopout(value: boolean) {
    popoutOpen.value = value;
}


return { __sfc: true,isCheckoutView, isBasketVisible, isOnSearchPage, showAuthTopBar, isCheckoutViewWithTopBar, menuTheme, usp, isB2BAuthenticated, lineItemsCount, isSearchOpen, isMiniBasketOpen, toggleSearch, toggleBasket, toggleNavigation, closeNavigationOverlays, addToBasketSuccess, basketSuccessTimer, popoutOpen, scrollCallbackIndex, lastAnchor, lastScrollTop, scrollSign, showNavigation, topBarNavigationWrapper, searchIconClicked, navigationIconClicked, onScroll, whiteText, menuIsWhite, splashColors, resetWrapperTransform, route, canOpenSearch, routeValues, onUrlChange, onLineItemCountChange, showAddToBasketSuccessAnimation, tryClearBasketSuccessTimer, togglePopout, MiniBasketB2b, MiniBasketB2c, OffcanvasNavigation, PortalTopBar, NavigationSearch, UspItem }
}

})